import { useState } from 'react';
import { useNavigate } from 'react-router';

import Dialog from 'components/Dialog';
import { useDialog } from 'context/DialogProvider/DialogProvider';
import ImportDialogContent from 'features/Import/components/ImportDialog/components/ImportDialogContent';
import useFetchData from 'hooks/useFetchData';
import { DRAFTS_PAGE_URL, IMPORT_API_URL, IMPORT_DIALOG_ID } from 'utils/defaults';

const ImportDialog = () => {
  const { isDialogOpen, closeDialog } = useDialog();
  const { postData } = useFetchData();
  const navigate = useNavigate();
  const [spaceIds, setSpaceIds] = useState<string[]>([]);

  const handleContinue = () => {
    postData(IMPORT_API_URL, spaceIds);
    navigate(DRAFTS_PAGE_URL);
    closeDialog(IMPORT_DIALOG_ID);
  };

  return (
    <Dialog
      isOpen={isDialogOpen(IMPORT_DIALOG_ID)}
      handleClose={() => closeDialog(IMPORT_DIALOG_ID)}
      handleContinue={() => handleContinue()}
      name="ImportDialog"
      title="Import"
      content={<ImportDialogContent setSpaceIds={setSpaceIds} />}
    />
  );
};

export default ImportDialog;
